import React from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
    return (
        <>
            <div className="flex items-center justify-center min-h-screen bg-cover bg-center bg-no-repeat">
                <div className="max-w-md mx-auto text-center bg-white bg-opacity-90 p-8 ">
                    <img src='/images/404.png' width={800}/>
                    <h1 className="text-4xl font-bold text-gray-800 mb-6">Oops! Page Not Found</h1>
                    <p className="text-lg text-gray-600 mb-8">The page you're looking for seems to have gone on a little adventure. </p>
                    <Link to="/"
                        className="inline-block bg-[#F2A549] text-white font-semibold px-6 py-3 rounded-md hover:bg-indigo-700 transition-colors duration-300">
                        Go Back Home
                    </Link>
                </div>
            </div>
        </>
    )
}

export default NotFound
